import { clearAgentConversations } from "./agentConversationStore";

const SessionHelper = {
  saveToSession: <T>(sessionKey: string, value: T) => {
    localStorage.setItem(sessionKey, JSON.stringify(value));
  },
  removeFromSession: (sessionKey: string) => {
    localStorage.removeItem(sessionKey);
  },

  /**
   * Ends a session by emptying storage. Storage is shared per origin, so a credential belonging to
   * a different session lives there too and would go with it -- `preserveKeys` is how such a
   * credential outlives the session being ended. `preserveKeyPrefixes` is the same for a family of
   * keys whose exact names are not known up front, such as one onboarding session per invite token.
   */
  clearSession: (preserveKeys: string[] = [], preserveKeyPrefixes: string[] = []) => {
    const shouldKeep = (key: string) =>
      preserveKeys.includes(key) || preserveKeyPrefixes.some((prefix) => key.startsWith(prefix));

    const kept = Object.keys(localStorage)
      .filter(shouldKeep)
      .map((key) => [key, localStorage.getItem(key)] as const)
      .filter(([, value]) => value !== null);

    localStorage.clear();
    kept.forEach(([key, value]) => localStorage.setItem(key, value as string));
    clearAgentConversations();
  },

  getSessionItem: <T>(sessionKey: string): T => {
    const item = localStorage.getItem(sessionKey);
    return item !== null ? JSON.parse(item) : null;
  },
};

export default SessionHelper;
